
import { computed, defineComponent, inject } from "vue";
import {
  FormValidatedValuesKey,
  FormValidatedUpdateKey,
  FormValidatedErrorsKey,
} from "../../types/inject";


export default defineComponent({
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    tclass: String,
  },
  setup(props) {
    const valuesOriginal = inject(FormValidatedValuesKey, {});
    const errorsOriginal = inject(FormValidatedErrorsKey, {});
    const valueOriginal = computed(
      () =>
        valuesOriginal &&
        (typeof valuesOriginal[props.name] === "string"
          ? parseInt(valuesOriginal[props.name] as string) === 1
          : typeof valuesOriginal[props.name] === "number"
          ? valuesOriginal[props.name] === 1
          : undefined)
    );

    const onUpdateOriginal = inject(FormValidatedUpdateKey);

    const values = computed<any>(() => valuesOriginal);

    const value = computed<boolean | undefined>(() => valueOriginal.value);

    const error = computed(() => errorsOriginal[props.name]);

    const onUpdate = inject(FormValidatedUpdateKey);

    const onChange = () => {
      typeof onUpdate === "function" &&
        onUpdate({ [props.name]: value.value ? 0 : 1 });
    };

    return {
      onChange,
      value,
      error,
    };
  },
});
